import React from 'react'
import styles from './Card_2.module.css'

export const Card_2 = () => {
    return (
        <div className={styles.container}>

            <div className={styles.card_header}>
                <h2>Tasks</h2>
                <button>View All</button>
            </div>

            <div className={styles.card_body}>

                <div className={styles.item}>
                    <div className={styles.left}>
                        <input type="checkbox" />
                        <div className={styles.user_container}>
                            <i class="fas fa-user-circle"></i>
                            <span>
                                <h5>Redesign header</h5>
                                <p>
                                    Alfa Zulqarnain
                                    <span className={styles.bullet}></span>
                                    <span className={styles.status}>Now</span>
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <button>Not Finished</button>
                    </div>
                </div>

                <div className={styles.item}>
                    <div className={styles.left}>
                        <input type="checkbox" />
                        <div className={styles.user_container}>
                            <i class="fas fa-user-circle"></i>
                            <span>
                                <h5>Redesign header</h5>
                                <p>
                                    Alfa Zulqarnain
                                    <span className={styles.bullet}></span>
                                    <span className={styles.status}>Now</span>
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <button>Not Finished</button>
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.left}>
                        <input type="checkbox" />
                        <div className={styles.user_container}>
                            <i class="fas fa-user-circle"></i>
                            <span>
                                <h5>Redesign header</h5>
                                <p>
                                    Alfa Zulqarnain
                                    <span className={styles.bullet}></span>
                                    <span className={styles.status}>Now</span>
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <button>Not Finished</button>
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.left}>
                        <input type="checkbox" />
                        <div className={styles.user_container}>
                            <i class="fas fa-user-circle"></i>
                            <span>
                                <h5>Redesign header</h5>
                                <p>
                                    Alfa Zulqarnain
                                    <span className={styles.bullet}></span>
                                    <span className={styles.status}>Now</span>
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <button>Not Finished</button>
                    </div>
                </div>

            </div>

        </div>
    )
}